<template>
  <div class="case-detail-data-list-gene-preview-result-page col-block width-full" :style="{ flex: 1 }">
    <div class="preview-main-container col-block width-full">
      <div class="preview-category-container col-block width-full">
        <div class="preview-category-block col-block width-full" v-for="(categoryOption, coindex) in previewSelectOptions.categoryOptions" :key="coindex">
          <div v-if="categoryOption.title !== '__DEFAULT'" class="preview-category-title-container row-block">
            <div class="preview-category-title-block row-block">
              <div class="preview-category-title">{{ $t(categoryOption.title) }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="preview-category-group-container col-block width-full">
            <div class="preview-category-group-block col-block width-full" v-for="(groupOption, goindex) in categoryOption.groupOptions" :key="goindex">
              <div v-if="groupOption.title !== '__DEFAULT'" class="preview-category-group-title-container row-block">
                <div class="preview-category-group-title-block row-block">
                  <div class="preview-category-group-title">{{ $t(groupOption.title) }}</div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="preview-category-group-content-list-container row-block flex-start flex-wrap stretch">
                <div class="preview-category-group-content-container col-block stretch" v-for="(formOption, foindex) in groupOption.options" :key="foindex" :style="{ width: formOption.long ? '18.75%' : '12.5%' }">
                  <div class="preview-category-group-content-block center-block title" :style="{ flex: 1 }">
                    <div class="preview-category-group-content">{{ $t(formOption.title) }}</div>
                  </div>
                  <div class="preview-category-group-content-block col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div
                      v-if="formOption.value"
                      class="preview-category-group-content ellipsis"
                      :title="localeMap((formOption.hover || formOption.value)(variant, gene))"
                      :class="formOption.class(formOption.value(variant, gene), variant, gene)"
                    >{{ valueMap(localeMap(formOption.value(variant, gene))) }}</div>
                    <a v-if="formOption.link" class="preview-category-group-content-link-container row-block" :href="formOption.link.url(variant, gene)" target="_blank">
                      <div :style="{ flex: 1 }"></div> 
                      <a class="preview-category-group-content-link link break-line shrink">{{ $t(formOption.link.title) }}</a>
                      <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                      <div :style="{ flex: 1 }"></div> 
                    </a>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { defaultEmptyDisplay, reportPreviewOptions } from '../../constants/global/data'
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    gene: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    displayAll () {
      return {
        'ps': true,
        'pd': false
      }[this.displayType]
    },
    selectedMap () {
      return this.defaultDatas.reduce((map, key) => ({ ...map, [key]: true }), {})
    },
    previewSelectOptions () {
      let previewSelectOptions = reportPreviewOptions[this.displayType].filter(option => (
        !option.old &&
        (option.resultDisplay || (() => true))(this.variant, this.user) &&
        (this.displayAll || this.selectedMap[option.key])
      ))
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: groupBy(previewSelectOptions, categoryOption => categoryOption.resultCategory || categoryOption.category).map(groupOptions => ({
          title: groupOptions[0].resultCategory || groupOptions[0].category,
          options: groupOptions,
          groupOptions: groupBy(groupOptions, groupOption => groupOption.resultGroup || groupOption.group).map(formOptions => ({
            title: formOptions[0].resultGroup || formOptions[0].group,
            options: formOptions
          }))
        }))
      }
      return previewSelectOptions
    }
  },
  methods: {
    valueMap (value) {
      return (value || value === 0) ? value : (value === null || value === '') ? this.$t(defaultEmptyDisplay.empty) : this.$t(defaultEmptyDisplay.noKey)
    },
    localeMap (value) {
      return value && (value + '').startsWith('CONSTANT.global.data') ? this.$t(value) : value
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/caseDetail/genePreviewResult.vue